var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"return-dashboard left-align",attrs:{"to":{name: 'Dashboard'}}},[_c('b-button',[_c('b-icon-arrow-left'),_vm._v(" Retourner au tableau de bord ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }